const featureItems = [
  {
    icon: 'ri-speed-up-line',
    title: '极速秒开',
    desc: '全球CDN加速节点覆盖，P2P智能分发技术确保影片秒开播放，告别缓冲等待，即点即看。',
    color: 'primary',
  },
  {
    icon: 'ri-4k-line',
    title: '4K蓝光',
    desc: '支持从标清到4K蓝光多档画质自由切换，高码率HDR资源还原影院级色彩与细节表现。',
    color: 'accent',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全可靠',
    desc: '所有资源经过严格安全审核，绿色无弹窗。采用HTTPS加密传输，保护您的观影隐私。',
    color: 'secondary',
  },
];

function getColorClasses(color: string) {
  switch (color) {
    case 'primary':
      return { bg: 'bg-primary-500/10', icon: 'text-primary-400', border: 'border-primary-500/20' };
    case 'accent':
      return { bg: 'bg-accent-500/10', icon: 'text-accent-400', border: 'border-accent-500/20' };
    case 'secondary':
      return { bg: 'bg-secondary-500/10', icon: 'text-secondary-400', border: 'border-secondary-500/20' };
    default:
      return { bg: 'bg-primary-500/10', icon: 'text-primary-400', border: 'border-primary-500/20' };
  }
}

export default function Features() {
  return (
    <section id="features" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[960px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-400 bg-secondary-500/10 rounded-full mb-4">
            平台特色
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            为什么选择桃子影院
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            三大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {featureItems.map((item, idx) => {
            const colors = getColorClasses(item.color);
            return (
              <div
                key={idx}
                className={`group bg-background-200/60 rounded-2xl p-6 border border-background-300/20 hover:${colors.border} transition-all duration-300 cursor-pointer text-center`}
              >
                <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl ${colors.bg} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${item.icon} ${colors.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-100 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}